import { EventCreationForm } from "@punchup/venues/client/components/tixologi-wizard/types";
import { TixologiResumedEvent } from "@punchup/data/legacy/tixologi";
import axios from "axios";
import { useMutation, UseMutateFunction } from "@tanstack/react-query";
import { useTixologi } from "@punchup/data/legacy/hooks";
import { buildTixologiEventPayload } from "../../events/buildTixologiEventPayload";

type TixologiProps = {
  id?: string;
  isComedian?: boolean;
};

type UseCreateTixologiEventReturn = {
  mutate: UseMutateFunction<
    { data: TixologiResumedEvent[] },
    Error,
    EventCreationForm,
    unknown
  >;
  isPending: boolean;
};

export function useCreateTixologiEvent({
  id,
  isComedian,
}: TixologiProps): UseCreateTixologiEventReturn {
  const { tixologiData } = useTixologi({ id, isComedian });

  const { mutate, isPending } = useMutation({
    mutationFn: async (
      event: EventCreationForm
    ): Promise<{ data: TixologiResumedEvent[] }> =>
      axios.post(
        process.env.NEXT_PUBLIC_TIXOLOGI_API_URL + "/punchup/events",
        buildTixologiEventPayload(event),
        { headers: { Authorization: `Bearer ${tixologiData?.token}` } }
      ),
  });

  return { mutate, isPending };
}
